<template>
  <div class="leave-word-detail">
    <div class="leave-word-detail-content">
      <van-row class="leave-word-detail-content-title">
        {{ leaveWordDetail.title }}
      </van-row>
      <van-row class="phoneNumber-and-createdDate">
        <van-row>
          <img src="../images/phone-number-icon.png" alt=""/>
          {{ leaveWordDetail.phoneNumber }}
        </van-row>
        <van-row class="line"></van-row>
        <van-row>
          <img src="../images/time-icon.png" alt=""/>
          {{ leaveWordDetail.createdDate }}
        </van-row>
        <van-row class="line"></van-row>
        <van-row>
          <img src="../images/volume-icon.png" alt=""/>
          {{ leaveWordDetail.readingVolume }}
        </van-row>
      </van-row>
      <van-row class="disable-van-field">
        <van-field placeholder="留言详情" type="textarea"
                   :disabled="true"
                   v-model="leaveWordDetail.content"
                   :autosize="true"/>
      </van-row>
      <van-row gutter="20">
        <van-col v-for="(item,index) in leaveWordDetail.leaveWordImageGetDtoList" :key="index" span="8">
          <van-image fit="contain" :src="item.imageUrl"
                     @click="handleClickImage(item.imageUrl)"/>
        </van-col>
      </van-row>
    </div>
    <van-divider :style="{borderColor:'#dcdcdc'}"/>
    <div class="leave-word-detail-reply" v-if="leaveWordDetail.leaveWordReplyGetDto">
      <van-row>
        <van-col :span="5">
          <img src="../images/head.png" alt=""/>
        </van-col>
        <van-col :span="13">
          <van-row class="leave-word-detail-reply-title">问题回复</van-row>
          <van-row class="leave-word-detail-reply-replyTime">
            {{ leaveWordDetail.leaveWordReplyGetDto.replyTime }}
          </van-row>
          <van-row>
          </van-row>
        </van-col>
        <van-col>
          <van-button type="info" size="mini"
                      class="attachment-button"
                      v-if="leaveWordDetail.leaveWordReplyGetDto.attachment"
                      @click="handleClickDownload(leaveWordDetail.leaveWordReplyGetDto.attachment)">
            <slot>
              <img width="12" height="12" src="../images/attachment-icon.png" alt=""/>
            </slot>
            附件下载
          </van-button>
        </van-col>
      </van-row>
      <van-row class="disable-van-field">
        <van-field placeholder="留言详情"
                   type="textarea"
                   disabled
                   v-model="leaveWordDetail.leaveWordReplyGetDto.replyContent"
                   :autosize="true"/>
      </van-row>
      <van-row>
      </van-row>
    </div>
  </div>
</template>

<script>
import leaveWordService from "@/leave-word/service/leave-word-service";
import {configManager} from "@zhoujianhui/vip-core";
import {ImagePreview} from "vant";

export default {
  name: "LeaveWordDetail",
  data() {
    return {
      leaveWordDetail: {
        leaveWordReplyGetDto: {}
      }
    }
  },
  created() {
    this.findLeaveWordDetailById();
  },
  methods: {
    async findLeaveWordDetailById() {
      let result = await leaveWordService.findLeaveWordDetailById(this.$route.query.id);
      if (result.isSuccess()) {
        this.leaveWordDetail = result.data;
        this.leaveWordDetail.leaveWordImageGetDtoList = result.data.leaveWordImageGetDtoList
            .map(item => {
              item.imageUrl = configManager.getConfig().axios.baseUrl + item.imageUrl;
              return item;
            });
        console.log(this.leaveWordDetail);
      } else {
        this.$toast(result.msg);
      }
    },
    handleClickImage(imageUrl) {
      ImagePreview([
        imageUrl
      ])
    },
    handleClickDownload(attachmentUrl) {
      window.location.href = configManager.getConfig().axios.baseUrl + attachmentUrl;
    }
  }
}
</script>
<style lang="scss" scoped>


.leave-word-detail {
  padding: 18% 4%;

  background-color: white;

  .disable-van-field {
    :deep(.van-field__control) {
      color: rgb(102, 102, 102);
      -webkit-text-fill-color: rgb(102, 102, 102);
      font-size: 13px;
    }
  }

  .van-row {
    margin-bottom: 15px;
  }

  .leave-word-detail-content {

    .leave-word-detail-content-title {
      font-weight: 600;
      font-size: 18px;
      /*字母数字换行*/
      word-wrap: break-word;
    }

    .phoneNumber-and-createdDate {
      color: #999999;
      display: flex;

      & img {
        vertical-align: middle;
      }

      .line {
        width: 1px;
        height: 14px;
        background: #999999;
        margin: 0 10px;
      }

    }
  }

  .leave-word-detail-reply {
    margin-top: 10px;

    .leave-word-detail-reply-title {
      font-weight: 600;
      font-size: 18px;
    }

    .leave-word-detail-reply-replyTime {
      color: #999999;
    }

    .attachment-button {
      margin-top: 20px;
    }
  }
}

.van-divider {
  margin: 0 0;
}
</style>
